import { fetchRulesByParams } from 'store/slices/rulesSlice';
import { useSearchParams } from 'react-router-dom';
import prepareSearchParams from 'utils/prepareSearchParams';
import { useCallback, useMemo } from 'react';
import { ISearchParams } from 'types/searchParams';
import { useAppDispatch, useAppSelector } from './typedReduxHooks';

export const useSearchRules = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { searchParams: savedSearchParams } = useAppSelector((state) => state.rules);
  const preparedSearchParams = prepareSearchParams(savedSearchParams);

  const getRules = useCallback(
    (params: Array<{ [key: string]: string | number } | ISearchParams>) => {
      if (!params.length || Object.keys(params).length === 0) {
        dispatch(fetchRulesByParams({}));

        return;
      }

      params.forEach((paramObj) => {
        const [paramName, paramValue] = Object.entries(paramObj)[0];

        dispatch(
          fetchRulesByParams({
            ...preparedSearchParams,
            ...Object.fromEntries(searchParams),
            [paramName]: paramValue,
          }),
        );
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preparedSearchParams, searchParams, dispatch],
  );

  return useMemo(() => ({
    getRules,
  }), [getRules]);
};

export default useSearchRules;
